const URI_SCHEME_IN_PATH = /^\/[a-z][a-z0-9+.-]*:/i;

function fullyDecode(value: string): string | null {
  let current = value;
  for (let i = 0; i < 10; i++) {          // cap iterations to prevent DoS
    let next: string;
    try {
      next = decodeURIComponent(current);
    } catch {
      return null;                          // malformed encoding — treat as unsafe
    }
    if (next === current) return current;   // stable — no further decoding possible
    current = next;
  }
  return null;                              // still changing after 10 passes — reject
}

function isSafeRelativePath(value: string): boolean {
  return value.startsWith('/') && !value.startsWith('//') && !URI_SCHEME_IN_PATH.test(value);
}

export function isSafeReturnPath(path: unknown): boolean {
  if (!path || typeof path !== 'string') return false;
  if (!isSafeRelativePath(path)) return false;
  const fullyDecoded = fullyDecode(path);
  if (fullyDecoded === null || !isSafeRelativePath(fullyDecoded)) return false;
  return true;
}

export function sanitizeReturnPath(path: unknown, fallback = '/settings'): string {
  return isSafeReturnPath(path) ? (path as string) : fallback;
}
